/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IdentitySourceName = {
    AzureTenant: 'azure_tenant',
    EntraTenant: 'entra_tenant',
    MicrosoftTenant: 'microsoft_tenant',
    AwsAccount: 'aws_account',
    AwsOrganization: 'aws_organization',
    GcpProject: 'gcp_project',
    GcpOrganization: 'gcp_organization',
    SnowflakeAccount: 'snowflake_account',
    DatabricksAccount: 'databricks_account',
    OktaOrg: 'okta_org',
    GoogleWorkspaceInstance: 'google_workspace_instance',
    SalesforceOrg: 'salesforce_org',
    ActiveDirectory: 'active_directory',
    PostgresInstance: 'postgres_instance',
    Auth0Domain: 'auth0_domain',
    KeeperAccount: 'keeper_account',
    OneloginOrganization: 'onelogin_organization',
    ServicenowInstance: 'servicenow_instance',
    Cyberark: 'cyberark',
    Anthropic: 'anthropic',
    Openai: 'openai',
    Slack: 'slack',
    Jira: 'jira',
    MongodbAtlas: 'mongodb_atlas',
    Indykite: 'indykite',
    MergeDevAccount: 'merge_dev_account',
    _7shiftsAccount: '7shifts_account',
    AdpDecidiumAccount: 'adp_decidium_account',
    AdpRunAccount: 'adp_run_account',
    AdpWorkforceNowAccount: 'adp_workforce_now_account',
    AlliancehcmAccount: 'alliancehcm_account',
    AlteraPayrollAccount: 'altera_payroll_account',
    BamboohrAccount: 'bamboohr_account',
    BreathehrAccount: 'breathehr_account',
    CezanneHrAccount: 'cezanne_hr_account',
    CharlieAccount: 'charlie_account',
    CharthopAccount: 'charthop_account',
    ClayhrAccount: 'clayhr_account',
    CoolcareAccount: 'coolcare_account',
    CyberarkTenant: 'cyberark_tenant',
    DarwinboxInstance: 'darwinbox_instance',
    DayforceInstance: 'dayforce_instance',
    DeelAccount: 'deel_account',
    EmploymentHeroAccount: 'employment_hero_account',
    FactorialAccount: 'factorial_account',
    FolksHrAccount: 'folks_hr_account',
    FreshteamAccount: 'freshteam_account',
    GustoAccount: 'gusto_account',
    HaileyHrAccount: 'hailey_hr_account',
    HibobAccount: 'hibob_account',
    HrCloudAccount: 'hr_cloud_account',
    HrPartnerAccount: 'hr_partner_account',
    HrworksAccount: 'hrworks_account',
    HumaansAccount: 'humaans_account',
    HumiAccount: 'humi_account',
    InsperityPremierAccount: 'insperity_premier_account',
    IntellihrTenant: 'intellihr_tenant',
    IrisCascadeAccount: 'iris_cascade_account',
    IsolvedInstance: 'isolved_instance',
    JumpcloudTenant: 'jumpcloud_tenant',
    JustworksAccount: 'justworks_account',
    KallidusTenant: 'kallidus_tenant',
    KekaAccount: 'keka_account',
    KenjoAccount: 'kenjo_account',
    LanoAccount: 'lano_account',
    LatticeHrisAccount: 'lattice_hris_account',
    LeapsomeAccount: 'leapsome_account',
    LuccaInstance: 'lucca_instance',
    MicrosoftEntraIdTenant: 'microsoft_entra_id_tenant',
    NamelyInstance: 'namely_instance',
    NmbrsAccount: 'nmbrs_account',
    OfficientAccount: 'officient_account',
    OracleCloudHumanCapitalManagementHcmInstance: 'oracle_cloud_human_capital_management_hcm_instance',
    OysterhrAccount: 'oysterhr_account',
    PaycaptainAccount: 'paycaptain_account',
    PaychexAccount: 'paychex_account',
    PaycomAccount: 'paycom_account',
    PaycorAccount: 'paycor_account',
    PayfitAccount: 'payfit_account',
    PaylocityInstance: 'paylocity_instance',
    PeoplehrAccount: 'peoplehr_account',
    PersonioAccount: 'personio_account',
    PingoneTenant: 'pingone_tenant',
    PlandayAccount: 'planday_account',
    ProliantAccount: 'proliant_account',
    RemoteAccount: 'remote_account',
    RevolutPeopleAccount: 'revolut_people_account',
    RipplingAccount: 'rippling_account',
    SageHrAccount: 'sage_hr_account',
    SagePeopleInstance: 'sage_people_instance',
    SapSuccessfactorsInstance: 'sap_successfactors_instance',
    SesameAccount: 'sesame_account',
    SimployerAccount: 'simployer_account',
    SquarePayrollAccount: 'square_payroll_account',
    TrinetAccount: 'trinet_account',
    TrinetHrPlatformAccount: 'trinet_hr_platform_account',
    UkgProInstance: 'ukg_pro_instance',
    UkgProWorkforceManagementInstance: 'ukg_pro_workforce_management_instance',
    UkgReadyInstance: 'ukg_ready_instance',
    WorkdayTenant: 'workday_tenant',
    ZeltAccount: 'zelt_account',
    ZohoPeopleAccount: 'zoho_people_account',
    SlashidIpBrowserExtension: 'slashid_ip_browser_extension',
    Slashid: 'slashid',
    GateInstance: 'gate_instance',
    Github: 'github',
    Scim: 'scim',
    BatonConnector: 'baton_connector',
    TestingDummy: 'testing_dummy',
    StaticFile: 'static_file',
    Failure: 'failure',
    ManualImport: 'manual_import'
} as const;
export type IdentitySourceName = typeof IdentitySourceName[keyof typeof IdentitySourceName];


export function instanceOfIdentitySourceName(value: any): boolean {
    for (const key in IdentitySourceName) {
        if (Object.prototype.hasOwnProperty.call(IdentitySourceName, key)) {
            if (IdentitySourceName[key as keyof typeof IdentitySourceName] === value) {
                return true;
            }
        }
    }
    return false;
}

export function IdentitySourceNameFromJSON(json: any): IdentitySourceName {
    return IdentitySourceNameFromJSONTyped(json, false);
}

export function IdentitySourceNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentitySourceName {
    return json as IdentitySourceName;
}

export function IdentitySourceNameToJSON(value?: IdentitySourceName | null): any {
    return value as any;
}

export function IdentitySourceNameToJSONTyped(value: any, ignoreDiscriminator: boolean): IdentitySourceName {
    return value as IdentitySourceName;
}

